module.exports = __webpack_public_path__ + "img/phone.bc6a9a74.svg";